import { access } from './access';
import { state } from './state';

const route = { access, state };

export { route }
